"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signTypedDataV4 = void 0;
const signTypedDataV4 = (client, payload) => __awaiter(void 0, void 0, void 0, function* () {
    if (!client.account) {
        throw new Error("The provided client is not a wallet client, or account not found on the client. Please provide an account during the client creation.");
    }
    const signature = yield client.signTypedData({
        account: client.account,
        domain: payload.domain,
        types: payload.types,
        message: payload.message,
        primaryType: payload.primaryType,
    });
    // Support both versions of `eth_sign` responses
    return signature.replace(/00$/, "1b").replace(/01$/, "1c");
});
exports.signTypedDataV4 = signTypedDataV4;
